<template>
  <div class="page">
    <v-container fluid>
      <v-form ref="form">
        <v-row class="justify-center mt-3">
          <v-col cols="3">
            <v-text-field
              v-model="form.filters.grupo"
              label="Grupo"
              outlined
              maxlength="40"
              dense
            ></v-text-field>
          </v-col>
          <v-col cols="3">
            <v-select
              v-model="form.filters.origem"
              :items="form.lists.origens"
              label="Origem"
              item-text="descricao"
              item-value="id"
              outlined
              dense
            ></v-select>
          </v-col>
          <sigfoco-select-ativo
            :cols="3"
            v-model="form.filters.situacao"
            labelType="Situação"
          ></sigfoco-select-ativo>
        </v-row>
        <div class="text-center">
          <v-col cols="12">
            <sigfoco-tooltip
              text="Buscar"
              icon="mdi-magnify"
              @click="buscarGrupos()"
            ></sigfoco-tooltip>
            <sigfoco-tooltip
              text="Limpar"
              icon="mdi-eraser"
              @click="resetForm()"
            ></sigfoco-tooltip>
            <sigfoco-tooltip
              text="Incluir"
              icon="mdi-plus"
              @click="openDialogManterGrupo()"
            ></sigfoco-tooltip>
          </v-col>
        </div>
      </v-form>
      <v-data-table
        class="mt-5"
        :headers="table.headers"
        :items="table.itens"
        :items-per-page="10"
        :footer-props="$footerProps"
      >
        <template v-slot:[`item.situacao`]="{ item }">
          <sigfoco-label-ativo-inativo :ativo="item.situacao"></sigfoco-label-ativo-inativo>
        </template>
        <template v-slot:[`item.origem`]="{ item }">
          {{ item.origem?.nome | uppercase }}
        </template>
        <template v-slot:[`item.acoes`]="{ item }">
          <sigfoco-tooltip
            text="Visualizar Grupo"
            icon="mdi-eye-outline"
            small
            @click="openDialogVisualizarGrupo(item)"
          ></sigfoco-tooltip>
          <sigfoco-tooltip
            text="Editar Grupo"
            icon="mdi-pencil"
            small
            @click="openDialogManterGrupo(item)"
          ></sigfoco-tooltip>
          <sigfoco-tooltip
            text="Excluir Grupo"
            icon="mdi-delete"
            small
            @click="excluirGrupo(item)"
          ></sigfoco-tooltip>
          <sigfoco-tooltip
            :text="`${item.situacao ? 'Inativar' : 'Ativar'} Grupo`"
            :icon="`${item.situacao ? 'mdi-toggle-switch' : 'mdi-toggle-switch-off'}`"
            :color="`${item.situacao ? 'var(--primary-button-color)' : 'silver'}`"
            small
            @click="alterarStatusGrupo(item)"
          ></sigfoco-tooltip>
        </template>
      </v-data-table>
    </v-container>
    <VisualizarGrupoDialog
      v-if="dialogVisualizarGrupo.visible"
      :visible="dialogVisualizarGrupo.visible"
      :content="dialogVisualizarGrupo.content"
      @onClose="dialogVisualizarGrupo.close()"
    ></VisualizarGrupoDialog>
    <CadastrarEditarGrupoDialog
      :tipos="form.lists.tipos"
      :edit="dialogManterGrupo.edit"
      :visible="dialogManterGrupo.visible"
      :content="dialogManterGrupo.content"
      @onClose="dialogManterGrupo.close()"
      @onSave="buscarGrupos()"
    ></CadastrarEditarGrupoDialog>
  </div>
</template>

<script>
import { Grupo } from "~/commons/classes/grupo";
import { Dialog } from "~/commons/classes/dialog";
import ManterGrupoService from "@/services/manter-grupo.service"
import VisualizarGrupoDialog from "./dialogs/VisualizarGrupoDialog.vue";
import CadastrarEditarGrupoDialog from "./dialogs/CadastrarEditarGrupoDialog.vue";
import OrigemEnum from '~/commons/enums/origem.enum';

export default {
  name: "ManterGrupoView",
  mixins: [ManterGrupoService],
  filters: {
    uppercase: (v) => v?.toUpperCase()
  },
  components: {
    VisualizarGrupoDialog,
    CadastrarEditarGrupoDialog
  },
  data: () => ({
    dialogManterGrupo: Dialog.Build(),
    dialogVisualizarGrupo: Dialog.Build(),
    form:{
      filters: {
        grupo: null,
        origem: null,
        situacao: null,
      },
      lists: {
        origens: OrigemEnum.values(),
      }
    },
    table: {
      headers: [
        { text: "Grupo", align: "center", value: "nome" },
        { text: "Origem", align: "center", value: "origem" },
        { text: "Situação", align: "center", value: "situacao" },
        { text: "Ações", align: "center", value: "acoes", sortable: false },
      ],
      itens: [],
    }
  }),
  methods: {
    buscarGrupos() {
      this.$buscarGrupos({ params: this.form.filters }).then(({ data }) => this.table.itens = data.lista)
    },
    resetForm() {
      this.$resetForm();
      this.table.itens = [];
      this.form.filters.situacao = null;
    },
    openDialogManterGrupo(grupo) {
      grupo
        ? this.$visualizarGrupo(grupo.id).then(({ data }) => this.dialogManterGrupo.open(new Grupo(data.resposta), true))
        : this.dialogManterGrupo.open(Grupo.Build());
    },
    openDialogVisualizarGrupo(grupo) {
      this.$visualizarGrupo(grupo.id).then(({ data }) => this.dialogVisualizarGrupo.open(new Grupo(data.resposta)));
    },
    excluirGrupo(grupo) {
      this.$swal({
        text: `Deseja confirmar a essa operação?`,
        type: "error",
        showCancelButton: true,
        confirmButtonText: `Confirmar`,
        cancelButtonText: `Cancelar`,
      }).then(() => {
        this.$excluirGrupo(grupo.id).then(
          ({ data }) => {
            this.$notifySuccess(data.mensagem);
            this.buscarGrupos();
          });
      });
    },
    alterarStatusGrupo(grupo) {
      this.$swal({
        text: `Deseja confirmar a ${ grupo.situacao ? "inativação" : "ativação" } do Grupo?`,
        type: "warning",
        showCancelButton: true,
        confirmButtonText: `Confirmar`,
        cancelButtonText: `Cancelar`,
      }).then(() => {
        this.$inativarAtivarGrupo(grupo.id).then(
          ({ data }) => {
            this.$notifySuccess(data.mensagem);
            this.buscarGrupos();
          });
      });
    },
  },
}
</script>